import React, {useState} from 'react'
import {motion} from 'framer-motion'
import SearchBar from './components/SearchBar'
import WordResult from './components/WordResult'
import EmptyState from './components/EmptyState'
import {searchWord} from './services/wordService'
import './App.css'

function App() {
  const [wordData, setWordData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSearch = async (word) => {
    setLoading(true)
    setError('')
    try {
      const data = await searchWord(word)
      if (!data) {
        setError(`Word "${word}" not found in the database.`)
        setWordData(null)
      } else {
        setWordData(data)
      }
    } catch (err) {
      console.error('Search error:', err)
      setError(`Database error: ${err.message}`)
      setWordData(null)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="app-gradient-bg">
      <div className="app-content">
        {/* Header */}
        <header className="header-bg shadow-sm">
          <div className="max-w-6xl mx-auto px-4 py-6">
            <motion.h1
              initial={{opacity: 0, y: -20}}
              animate={{opacity: 1, y: 0}}
              className="text-3xl font-bold text-center text-primary"
            >
              Phoneme-Grapheme Word Mapper
            </motion.h1>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-6xl mx-auto px-4 py-8">
          <div className="space-y-8">
            {/* Search Section */}
            <SearchBar
              onSearch={handleSearch}
              loading={loading}
              error={error}
            />

            {/* Results Section */}
            <div className="min-h-[400px] flex items-center justify-center">
              {wordData ? (
                <WordResult wordData={wordData} />
              ) : (
                <EmptyState />
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default App